import { forwardRef } from 'react';
import { clsx } from 'clsx';
import { Box, type BoxProps } from '../Box/Box';
import { gridContainerRecipe, gridItemRecipe, mdOverrides } from './grid.css';

// MUI Grid v2 uses size={{ xs: 12, md: 4 }} syntax
type GridSize = { xs?: 3 | 4 | 6 | 12; md?: 3 | 4 | 6 | 12 };

export type GridProps = BoxProps & {
  container?: boolean;
  spacing?: 0 | 1 | 2 | 3 | 4;
  size?: GridSize;
};

export const Grid = forwardRef<HTMLElement, GridProps>(
  ({ container, spacing = 2, size, className, ...props }, ref) => {
    const containerClass = container ? gridContainerRecipe({ spacing }) : undefined;
    const itemClass = !container && size ? gridItemRecipe({ xs: size.xs ?? 12 }) : undefined;
    const mdClass = !container && size?.md ? mdOverrides[size.md] : undefined;

    return (
      <Box
        ref={ref}
        className={clsx(containerClass, itemClass, mdClass, className)}
        {...props}
      />
    );
  },
);
Grid.displayName = 'Grid';
